import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { EASE } from "./Reveal";

export default function FAQAccordion({ items, idPrefix = "faq" }) {
  const [open, setOpen] = useState(0);
  return (
    <div className="divide-y divide-line border-y border-line" data-testid={`${idPrefix}-accordion`}>
      {items.map((item, i) => {
        const isOpen = open === i;
        return (
          <div key={`${idPrefix}-${i}`}>
            <h3>
              <button
                type="button"
                data-testid={`${idPrefix}-trigger-${i}`}
                aria-expanded={isOpen}
                aria-controls={`${idPrefix}-panel-${i}`}
                onClick={() => setOpen(isOpen ? -1 : i)}
                className="group flex w-full items-center justify-between gap-6 py-6 text-left"
              >
                <span className="flex items-baseline gap-4">
                  <span className="hidden font-display text-sm italic text-champagne sm:inline">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="font-display text-xl font-medium text-ink transition-colors group-hover:text-taupe md:text-2xl">
                    {item.q}
                  </span>
                </span>
                <span
                  className={`flex h-10 w-10 shrink-0 items-center justify-center border border-line transition-all duration-300 ${
                    isOpen ? "rotate-45 border-champagne bg-champagne/10" : "group-hover:border-champagne"
                  }`}
                >
                  <Plus className="h-4 w-4 text-champagne" />
                </span>
              </button>
            </h3>
            <AnimatePresence initial={false}>
              {isOpen && (
                <motion.div
                  id={`${idPrefix}-panel-${i}`}
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.45, ease: EASE }}
                  className="overflow-hidden"
                >
                  <p className="max-w-2xl pb-7 pr-8 text-base leading-relaxed text-soften sm:pl-10">
                    {item.a}
                  </p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
}
